import { render } from "./home.vue?vue&type=template&id=1fa7b3ad"
const script = {}

import exportComponent from "/home/bovero/Downloads/sito_vue3/vueboot5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__